import { Dialog } from '@blueprintjs/core'
import { useConsent } from 'setup/ConsentContext'
import { Button } from 'components/Button'
import { Colors } from 'design/colors'

export default function ConsentModal() {
  const { isLoading, hasConsented, grantConsent, revokeConsent } = useConsent()

  return (
    <Dialog
      isOpen={!isLoading && hasConsented === undefined}
      canOutsideClickClose={false}
      canEscapeKeyClose={false}
      style={{
        backgroundColor: Colors.DARK_GREEN,
        padding: 24,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 440
      }}
    >
      <div style={{ color: Colors.WHITE, fontSize: 18, fontWeight: 'bold', marginBottom: 12 }}>
        Analytics & Error Reporting
      </div>
      <div style={{ color: Colors.WHITE, fontSize: 14, marginBottom: 24, lineHeight: 1.5 }}>
        We use Sentry to automatically capture errors and help us improve S-Lab.
      </div>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
        <Button
          style={{ width: 90 }}
          onClick={revokeConsent}
          backgroundColor={Colors.DARK_GREEN}
          textColor={Colors.WHITE}
        >
          Decline
        </Button>
        <Button
          style={{ width: 90 }}
          onClick={grantConsent}
          backgroundColor={Colors.BUTTON_GREEN}
          textColor={Colors.WHITE}
        >
          Accept
        </Button>
      </div>
    </Dialog>
  )
}
